// extracted by mini-css-extract-plugin
module.exports = {"subtitle":"Subtitle_subtitle__3_tIk","input":"Subtitle_input__1IByq","moreBtn":"Subtitle_moreBtn__30nXx"};